import { render, staticRenderFns } from "./detailNoJournalistModal.vue?vue&type=template&id=271726dc&"
import script from "./detailNoJournalistModal.vue?vue&type=script&lang=js&"
export * from "./detailNoJournalistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports